import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: { main: '#0D47A1' },
    secondary: { main: '#0288D1' },
    background: { default: '#EEF2F7', paper: '#ffffff' },
  },
  shape: { borderRadius: 10 },
  typography: { fontFamily: '"Inter", "Roboto", sans-serif' },
  components: {
    MuiCard: { styleOverrides: { root: { boxShadow: '0 2px 12px rgba(0,0,0,0.08)' } } },
    MuiButton: { styleOverrides: { root: { textTransform: 'none', fontWeight: 600 } } },
    MuiDialog: { styleOverrides: { paper: { margin: 16, width: 'calc(100% - 32px)', maxHeight: 'calc(100% - 64px)' } } },
  },
});

export default theme;
